import Vue from 'vue'

const mobileChecker = {
  install(vue, opts){
    // Create plugin's root Vue instance
    const root = new Vue({
        data: {
          width: window.innerWidth
        },
        computed: {
          mobile () {
            return this.width < 480
          },
          desktop () {
            return this.width > 768
          }
        },
        created () {
          window.addEventListener('resize', () => {
            this.width = window.innerWidth
          })
        }
    })
    
    // Make the root instance available in all components
    vue.prototype.$screen = root
  }
}

Vue.use(mobileChecker)


// WEBPACK FOOTER //
// ./src/mobileCheck.js